module.exports = __webpack_public_path__ + "static/img/location_icon.0be8febe.svg";